import React, { useEffect, useState } from 'react';

import { ExtractionIssuesV2 } from '../../../pages/Project/ProjectListV2/ExtractionIssuesV2';
import { TransformationV2 } from '../../../pages/Project/ProjectListV2/TransformationV2';
import { useWorkflowChrome } from '../WorkflowChromeContext';
import { STAGE_FOR_STEP } from './steps';
import { usePeriodRun } from './PeriodRunContext';
import { useGetWorkflowById } from '../../../services/workflow.services';
import { useUserGroupsCurrentUserAdminState } from '../../../services/user.service';
import { permissionPolicies } from '../../../permissions/policies';

/* What the run shows while the machine is working through sheets. */
const RunSheets = () => {
  const chrome = useWorkflowChrome();
  const { run, period, state, tiles } = usePeriodRun();
  const [closedFor, setClosedFor] = useState(null);

  const mine = !!run && run.periodId === chrome.periodId;

  /* The same question the band asks before it offers to start a run. */
  const { data: workflow } = useGetWorkflowById({
    id: run?.workflowId,
    queryParams: { enabled: !!run?.workflowId }
  });
  const { data: currentUser } = useUserGroupsCurrentUserAdminState();
  const canManage = permissionPolicies.checkAccess({
    currentUserRole: currentUser?.role,
    currentUserId: currentUser?.azure_object_id,
    assignedTo: workflow?.assigned_to
  });

  const stage = chrome.activeStageKey;
  const forStage =
    stage === STAGE_FOR_STEP.extraction
      ? 'extraction'
      : stage === STAGE_FOR_STEP.transformation
        ? 'transformation'
        : null;

  const working =
    state?.status === 'busy' ||
    state?.status === 'step' ||
    state?.status === 'asked' ||
    state?.status === 'settled';

  useEffect(() => {
    if (closedFor && closedFor !== forStage) setClosedFor(null);
  }, [forStage, closedFor]);

  const [heldFor, setHeldFor] = useState(null);
  useEffect(() => {
    if (working && forStage) setHeldFor(forStage);
    else if (!run || !forStage) setHeldFor(null);
  }, [working, forStage, run]);

  /* Mounted only where it belongs. */
  const belongs = mine && !!forStage && (working || heldFor === forStage);
  const open = belongs && closedFor !== forStage;

  if (!belongs) return null;

  const common = {
    isOpen: open,
    onClose: () => setClosedFor(forStage),
    periodId: run?.periodId,
    worklowId: run?.workflowId,
    refetch: () => {},
    canManageWorkflow: canManage,
    /* Empty because the work has only just been asked for, not because it came back clean. */
    isStarting: tiles.length === 0
  };

  return (
    <>
      {forStage === 'extraction' && <ExtractionIssuesV2 {...common} />}
      {forStage === 'transformation' && <TransformationV2 {...common} period={period} />}
    </>
  );
};

export default RunSheets;
